import { MinioFileInput, MinioImageInput } from "@tt/ttms-react-core";
import RichTextInput from "ra-input-rich-text";
import * as React from "react";
import {
  BooleanInput,
  Edit,
  FormTab,
  ReferenceArrayInput,
  ReferenceInput,
  SaveButton,
  SelectArrayInput,
  SelectInput,
  TabbedForm,
  TextInput,
  Toolbar,
  required,
  useNotify,
  useRedirect,
} from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";
import QRCodeGenerator from "../../components/QRCde/QRCodeGenerator";

const VideoDetailTitle = ({ record }: any) => {
  return <span>Video: {record ? `"${record.title}"` : ""}</span>;
};

const VideoEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton disabled={props.pristine} />
  </Toolbar>
);

const VideoEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify(`Video: "${data.title}" updated`);
    redirect("/video-list");
  };

  return (
    <AuthorizedCheck isAdmin={true}>
      <Edit {...props} undoable={false} title={<VideoDetailTitle />} onSuccess={onSuccess}>
        <TabbedForm toolbar={<VideoEditToolbar />}>
          <FormTab label="VIDEO">
            {/* <VideoField />
                    <MinioField source='thumbnailPath'>
                        <MinioVideoField />
                    </MinioField>
                    <MinioField source='thumbnailPath'>
                        <ImageField />
                    </MinioField> */}
            <MinioFileInput
              source="videoPath"
              label="Video file"
              accept="video/*"
              validate={required("Video yükleyin ve max. 800mb")}
              maxSize={800000000}
            />
            <MinioImageInput source="thumbnailPath" label="Video poster" accept="image/*" />
          </FormTab>
          <FormTab label="DETAILS">
            <TextInput source="title" label="Title" multiline validate={required()} />
            <ReferenceInput label="Category" source="categoryId" reference="categorys" sort={{ field: "name", order: "ASC" }}>
              <SelectInput optionText="name" optionValue="id" validate={required()} />
            </ReferenceInput>
            <ReferenceArrayInput label="Chapter" source="chapterId" reference="traxchapters" sort={{ field: "chapter", order: "ASC" }} perPage={100}>
              <SelectArrayInput optionText="chapter" optionValue="chapter" validate={required()} />
            </ReferenceArrayInput>
            <BooleanInput label="Suggested Video" source="isSuggested" />
            <ReferenceInput label="Status" source="status" reference="videostatuss">
              <SelectInput optionText="name" optionValue="id" validate={required()}></SelectInput>
            </ReferenceInput>
          </FormTab>
          <FormTab label="DESCRIPTION">
            <RichTextInput source="description" validate={required()} />
          </FormTab>
          <FormTab label="QR Code">
            <QRCodeGenerator />
          </FormTab>
        </TabbedForm>
      </Edit>
    </AuthorizedCheck>
  );
};

export default VideoEdit;
